import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountCrmModule} from 'src/openapi/admin/models/AccountCrmModule';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultCrmIntegrationSlice = getCachedTableDataSlice<
    Record<string, AccountCrmModule>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultCrmIntegration');

export const accountSearchResultCrmIntegrationActions = accountSearchResultCrmIntegrationSlice.actions;

const accountSearchResultCrmIntegrationCacheSelector: CachedTableCacheSelector<Record<string, AccountCrmModule>>
    = state => state.userPage.tabs.assignedAccounts.crmIntegration.cache;
export const accountSearchResultCrmIntegrationDataSelector: CachedTableDataSelector<Record<string, AccountCrmModule>>
    = state => state.userPage.tabs.assignedAccounts.crmIntegration;
export const accountSearchResultCrmIntegrationResultSelector = getCachedTableResultSelector(
    accountSearchResultCrmIntegrationCacheSelector,
    accountSearchResultStateSelector,
);
